module.exports = __webpack_public_path__ + "img/month-sticker.d66237ad.svg";